import React, { useState, useEffect, useRef, useContext } from "react";
import { NavLink } from "react-router-dom";
import "./ScrollableSideBar.css";
import styled from "styled-components";

import Team from "../assets/icons/social.svg";
import Registration from "../assets/icons/registration.png";
import Settings from "../assets/icons/settings.svg";
import Spreadsheet from "../assets/icons/planilha.png";
import Chatbot from "../assets/icons/Chatbot.png";
import FixedCost from "../assets/icons/fixedcost.png";
import SupplierProducts from "../assets/icons/supplier.png";
import Production from "../assets/icons/production.png";
import Clothing from "../assets/icons/clothing.png";
import ExecuteAxios from "Components/ExecuteAxios/ExecuteAxios";
import { AuthContext } from "Contexts/auth";


const Sidebar = () => {
  const { user } = useContext(AuthContext);
  const currentModule = user.module;

  const menuItems = [
    { path: "/spreadsheet", key: "spreadsheet", icon: Spreadsheet, label: "Orçamentos", id: 2 },
    { path: "/production", key: "production", icon: Production, label: "Produção", id: 3 },
    { path: "/products", key: "products", icon: Clothing, label: "Produtos", id: 4 },
    { path: "/suppliers", key: "suppliers", icon: SupplierProducts, label: "Fornecedores", id: 5 },
    { path: "/panel-cost", key: "panel-cost", icon: FixedCost, label: "Custo Fixo", id: 6 },
    { path: "/user-calendar", key: "user-calendar", icon: Registration, label: "Planejamento", id: 7, widthImg: "28px" },
    { path: "/people", key: "people", icon: Team, label: "Pessoas", id: 8 },
    { path: "/configuration", key: "configuration", icon: Settings, label: "Cadastros", id: 9 },
  ];

  const moduleScreens = {
    OCMT: ["spreadsheet", "people", "panel-cost", "configuration"],
    OCMT_PRD: ["spreadsheet", "production", "products", "suppliers", "panel-cost", "people", "configuration"],
    OCMT_PRD_BLCT: ["spreadsheet", "production", "products", "suppliers", "panel-cost", "user-calendar", "people", "configuration"],
    OCMT_PRD_QTRZ: ["spreadsheet", "production", "products", "suppliers", "panel-cost", "user-calendar", "people", "configuration"],
    OCMT_PRD_BLCT_QTRZ: ["spreadsheet", "production", "products", "suppliers", "panel-cost", "user-calendar", "people", "configuration"],
  };

  const allowedRoutes = moduleScreens[currentModule] || [];

  const [allowedScreens, setAllowedScreens] = useState(() => {
    return JSON.parse(localStorage.getItem("allowedScreens")) || [];
  });
  const [isLoading, setIsLoading] = useState(allowedScreens.length === 0);
  const [click, setClick] = useState(false);

  useEffect(() => {
    const fetchAllowedScreens = async () => {
      const response = await ExecuteAxios.api('get', '/profile-screens/get-profile-screens-ids-by-profile/') || [];
      const storedScreens = JSON.parse(localStorage.getItem("allowedScreens")) || [];

      if (JSON.stringify(response) !== JSON.stringify(storedScreens)) {
        setAllowedScreens(response);
        localStorage.setItem("allowedScreens", JSON.stringify(response));
      }

      setIsLoading(false);
    };

    fetchAllowedScreens();
  }, []);


  function getWidthImg(widthImg) {
    return widthImg ? widthImg : '30px'
  }

  const handleClick = () => setClick(!click);
  const validateSelected = (iconName) => window.location.pathname === iconName;

  return (
    <>
      {click && <Backdrop onClick={() => setClick(false)} />}
      <SidebarContainer clicked={click}>
        <Validate>
          <Button
            clicked={click}
            onClick={handleClick}
            style={{ cursor: 'pointer' }}
            aria-label={click ? 'Recolher menu' : 'Expandir menu'}
            aria-expanded={click}
          />
        </Validate>
        <SlickBar clicked={click} className="scrollable-content-side-bar">
          {menuItems.map(({ path, key, icon, label, id, widthImg, allowed }) => {
            if (isLoading) {
              return (
                <SkeletonItem key={id} />
              );
            }
            return (
              allowedScreens.some(item => id === item.id) &&
              allowedRoutes.includes(key) && (
                <Item key={id} itemSelected={validateSelected(path)} activeClassName="active" to={path} title={label}>
                  <img
                    src={icon}
                    style={{ maxHeight: '30px', maxWidth: '30px', width: getWidthImg(widthImg), margin: "0px" }}
                    alt={label}
                  />
                  <IconName clicked={click}>
                    <Text clicked={click}>{label}</Text>
                  </IconName>
                </Item>
              )
            );
          })}
        </SlickBar>
      </SidebarContainer>
    </>
  );
};

const SkeletonItem = styled.div`
  width: calc(100% - 20px);
  height: 30px;
  background: rgba(255, 255, 255, 0.15);
  margin: 12px 10px;
  border-radius: 8px;
  animation: pulse 1.5s infinite ease-in-out;

  @keyframes pulse {
    0% { opacity: 0.6; }
    50% { opacity: 1; }
    100% { opacity: 0.6; }
  }
`;

const SidebarContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--color-brand-800);

  /* Tablet: a barra aberta flutua sobre o conteúdo */
  @media (max-width: 1180px) {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: auto;
    z-index: ${({ clicked }) => (clicked ? 200 : "auto")};
    box-shadow: ${({ clicked }) => (clicked ? "8px 0 24px rgba(0, 0, 0, 0.25)" : "none")};
  }
`;

const Backdrop = styled.div`
  display: none;

  @media (max-width: 1180px) {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(10, 20, 45, 0.35);
    z-index: 199;
  }
`;

const Validate = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: max-content;
  padding: 10px 8px;
`;

const Button = styled.button`
  background-color: transparent;
  width: 48px;
  height: 44px;
  border: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.08);
  }

  &::before,
  &::after {
    content: "";
    background-color: white;
    height: 3px;
    width: 1.25rem;
    border-radius: 2px;
    position: absolute;
    transition: transform 0.3s ease;
  }

  &::before {
    transform: ${({ clicked }) => (clicked ? "rotate(135deg)" : "translateY(-4px)")};
  }
  &::after {
    transform: ${({ clicked }) => (clicked ? "rotate(-135deg)" : "translateY(4px)")};
  }
`;

const SlickBar = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  padding: 0;
  margin: 0;
  width: ${({ clicked }) => (clicked ? "var(--sidebar-width-open)" : "var(--sidebar-width)")};
  transition: width 0.3s ease-in-out;
  overflow-y: auto;
  overflow-x: hidden;
`;

const Item = styled(NavLink)`
  text-decoration: none;
  color: white;
  width: calc(100% - 12px);
  cursor: pointer;
  margin: 4px 6px;
  display: flex;
  align-items: center;
  padding: 0 11px;
  min-height: 48px;
  max-height: 48px;
  border-radius: 10px;
  flex-shrink: 0;
  background: ${({ itemSelected }) => (itemSelected ? "rgba(255, 255, 255, 0.12)" : "transparent")};
  transition: background 0.2s ease-in-out;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    img {
      filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
    }
  }

  img {
    width: 1.6rem;
    height: auto;
    flex-shrink: 0;
    transition: filter 0.25s ease-in-out;
    filter: ${({ itemSelected }) =>
    itemSelected
      ? "invert(100%) sepia(0%) saturate(100%) hue-rotate(200deg) brightness(120%) contrast(100%)"
      : "invert(70%) sepia(20%) saturate(500%) hue-rotate(200deg) brightness(80%) contrast(90%)"};
  }
`;

const IconName = styled.div`
  margin-left: 1rem;
  align-items: center;
  min-width: 100px;
  display: ${({ clicked }) => (clicked ? "flex" : "none")};
`;

const Text = styled.span`
  overflow: hidden;
  transition: color 0.3s ease-in-out;
  color: ${({ clicked }) => (clicked ? 'white' : 'transparent')};
  display: flex;
  white-space: nowrap;
  font-size: 0.95em;
  font-weight: 500;
`;

export default Sidebar;
